module.exports = __webpack_public_path__ + "media/images/step-three-selected-a84f75dd.svg";